/* ============================================================
   Rêve by K — global theme JavaScript
   Theme by Zobaer Dev · https://zobaer.me
   Vanilla, dependency-free, accessible. Toggles CLASSES and sets
   CSS variables via setProperty — never writes inline style strings.
   Every module is defensive (no-ops when its elements are absent),
   scope-aware (can re-init a single section), and idempotent
   (boundOnce guards prevent duplicate event listeners).
   Fully integrated with the Shopify theme editor:
   shopify:section:load / :unload / :select / block:select.
   ============================================================ */
(function () {
  "use strict";

  var REDUCED = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  function DESIGN() { return !!(window.Shopify && window.Shopify.designMode); }
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var on = function (el, ev, fn, opt) { if (el) el.addEventListener(ev, fn, opt || false); };
  /* Returns true the FIRST time it sees (el, key); false thereafter.
     Lets every binder run repeatedly (on section reload) without stacking listeners. */
  var boundOnce = function (el, key) { if (!el) return false; var k = "_b_" + key; if (el[k]) return false; el[k] = 1; return true; };

  /* ---------- Focus trap helper ---------- */
  function trapFocus(container) {
    var sel = 'a[href],button:not([disabled]),input:not([disabled]),select,textarea,[tabindex]:not([tabindex="-1"])';
    var nodes = $$(sel, container).filter(function (n) { return n.offsetParent !== null; });
    if (!nodes.length) return function () {};
    var first = nodes[0], last = nodes[nodes.length - 1];
    function handler(e) {
      if (e.key !== "Tab") return;
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
    container.addEventListener("keydown", handler);
    return function () { container.removeEventListener("keydown", handler); };
  }

  /* ---------- Overlay manager: drawers / search / cart ---------- */
  var OverlayManager = (function () {
    var openEl = null, lastTrigger = null, releaseTrap = null;
    function close() {
      if (!openEl) return;
      openEl.classList.remove("is-open");
      openEl.setAttribute("aria-hidden", "true");
      var bd = $(".backdrop"); if (bd) bd.classList.remove("is-open");
      document.body.classList.remove("no-scroll");
      var trigger = $('[aria-controls="' + openEl.id + '"]');
      if (trigger) trigger.setAttribute("aria-expanded", "false");
      if (releaseTrap) { releaseTrap(); releaseTrap = null; }
      if (lastTrigger) lastTrigger.focus();
      openEl = null;
    }
    function open(el, trigger) {
      if (!el) return;
      close();
      openEl = el; lastTrigger = trigger || null;
      el.classList.add("is-open");
      el.setAttribute("aria-hidden", "false");
      var bd = $(".backdrop"); if (bd) bd.classList.add("is-open");
      document.body.classList.add("no-scroll");
      if (trigger) trigger.setAttribute("aria-expanded", "true");
      releaseTrap = trapFocus(el);
      var focusable = $("[autofocus]", el) || $('input:not([type=hidden]),button,a[href]', el);
      if (focusable) window.setTimeout(function () { focusable.focus(); }, 350);
    }
    return { open: open, close: close, current: function () { return openEl; } };
  })();

  /* Overlay open/close triggers live inside sections (header) → scope + guard. */
  function initOverlayTriggers(root) {
    root = root || document;
    $$("[data-overlay-open]", root).forEach(function (btn) {
      if (!boundOnce(btn, "ovo")) return;
      on(btn, "click", function (e) {
        e.preventDefault();
        var target = document.getElementById(btn.getAttribute("aria-controls") || btn.getAttribute("data-overlay-open"));
        OverlayManager.open(target, btn);
      });
    });
    $$("[data-overlay-close]", root).forEach(function (b) { if (boundOnce(b, "ovc")) on(b, "click", OverlayManager.close); });
  }
  /* Document/backdrop listeners → bind once globally. */
  function initOverlayGlobal() {
    on($(".backdrop"), "click", OverlayManager.close);
    on(document, "keydown", function (e) { if (e.key === "Escape") OverlayManager.close(); });
  }

  /* ---------- Sticky header (on-scroll-up) ----------
     Binds the window listener once but re-queries [data-header] live each tick,
     so editing the Header section (which replaces the node) never leaves a stale closure. */
  var stickyBound = false;
  function initStickyHeader() {
    if (stickyBound || !$("[data-header]")) return;
    stickyBound = true;
    var lastY = window.pageYOffset, ticking = false;
    function update() {
      var header = $("[data-header]"); if (!header) { ticking = false; return; }
      var mode = header.getAttribute("data-sticky") || "always";
      var y = window.pageYOffset;
      header.classList.toggle("is-scrolled", y > 10);
      if (mode === "on-scroll-up") header.classList.toggle("is-hidden", y > lastY && y > header.offsetHeight);
      lastY = y; ticking = false;
    }
    on(window, "scroll", function () { if (!ticking) { window.requestAnimationFrame(update); ticking = true; } }, { passive: true });
    update();
  }

  /* ---------- Desktop megamenu + dropdown (hover + keyboard) ---------- */
  function initDesktopNav(root) {
    root = root || document;
    $$(".nav__item", root).forEach(function (item) {
      if (!boundOnce(item, "nav")) return;
      var trigger = $(".nav__link", item);
      var panel = $(".megamenu", item) || $(".dropdown", item);
      if (!trigger || !panel) return;
      var closeTimer;
      function openP() { window.clearTimeout(closeTimer); panel.classList.add("is-open"); trigger.setAttribute("aria-expanded", "true"); }
      function closeP() { panel.classList.remove("is-open"); trigger.setAttribute("aria-expanded", "false"); }
      on(item, "mouseenter", openP);
      on(item, "mouseleave", function () { closeTimer = window.setTimeout(closeP, 200); });
      on(trigger, "click", function (e) { e.preventDefault(); panel.classList.contains("is-open") ? closeP() : openP(); });
      on(trigger, "keydown", function (e) {
        if (e.key === "Enter" || e.key === " ") { e.preventDefault(); openP(); var f = $("a,button", panel); if (f) f.focus(); }
        if (e.key === "Escape") { closeP(); trigger.focus(); }
      });
      on(item, "focusout", function (e) { if (!item.contains(e.relatedTarget)) closeP(); });
    });
  }

  /* ---------- Search tabs / generic tabs ---------- */
  function initTabs(root) {
    root = root || document;
    $$('[role="tablist"]', root).forEach(function (list) {
      if (!boundOnce(list, "tabs")) return;
      var tabs = $$('[role="tab"], .tab', list);
      tabs.forEach(function (tab) {
        on(tab, "click", function () {
          tabs.forEach(function (t) { t.setAttribute("aria-selected", "false"); });
          tab.setAttribute("aria-selected", "true");
          var key = tab.getAttribute("data-tab");
          var scope = list.closest("[data-tabs]") || document;
          $$(".tabpanel", scope).forEach(function (p) { p.classList.toggle("is-active", p.getAttribute("data-panel") === key); });
        });
      });
    });
  }

  /* ---------- Quantity steppers ---------- */
  function initQuantity(root) {
    root = root || document;
    $$("[data-qty]", root).forEach(function (wrap) {
      if (!boundOnce(wrap, "qty")) return;
      var minus = $("[data-minus]", wrap), plus = $("[data-plus]", wrap), val = $("[data-val]", wrap) || $("input", wrap);
      if (!val) return;
      function get() { return parseInt(val.value || val.textContent, 10) || 1; }
      function set(n) { n = Math.max(1, n); if ("value" in val) val.value = n; else val.textContent = n; val.dispatchEvent(new Event("change", { bubbles: true })); }
      on(minus, "click", function () { set(get() - 1); });
      on(plus, "click", function () { set(get() + 1); });
    });
  }

  /* ---------- Slideshow / hero carousel (scroll-snap) ---------- */
  function initSlideshow(root) {
    root = root || document;
    $$("[data-slideshow]", root).forEach(function (slideshow) {
      if (!boundOnce(slideshow, "slides")) return;
      var track = $("[data-slides]", slideshow); if (!track) return;
      var slides = track.children.length, idx = 0;
      var num = $("[data-slide-current]", slideshow);
      var auto = parseInt(slideshow.getAttribute("data-autoplay"), 10) || 0;
      function show(n) { idx = (n + slides) % slides; track.scrollTo({ left: track.clientWidth * idx, behavior: REDUCED ? "auto" : "smooth" }); if (num) num.textContent = ("0" + (idx + 1)).slice(-2); }
      slideshow._goToSlide = show;
      on($("[data-next]", slideshow), "click", function () { show(idx + 1); });
      on($("[data-prev]", slideshow), "click", function () { show(idx - 1); });
      on(track, "scroll", function () { var i = Math.round(track.scrollLeft / track.clientWidth); if (i !== idx) { idx = i; if (num) num.textContent = ("0" + (idx + 1)).slice(-2); } }, { passive: true });
      /* Autoplay never runs in the theme editor (so merchants can edit slides). */
      if (auto > 0 && !REDUCED && slides > 1 && !DESIGN()) {
        slideshow._timer = window.setInterval(function () { show(idx + 1); }, auto);
        on(slideshow, "mouseenter", function () { window.clearInterval(slideshow._timer); });
      }
    });
  }

  /* ---------- Announcement rotator ---------- */
  function initAnnouncement(root) {
    root = root || document;
    $$("[data-announce]", root).forEach(function (bar) {
      if (!boundOnce(bar, "announce")) return;
      var msgs = $$("[data-announce-msg]", bar);
      if (msgs.length < 2) return;
      var idx = 0;
      function show(n) { idx = (n + msgs.length) % msgs.length; msgs.forEach(function (m, i) { m.classList.toggle("is-active", i === idx); }); }
      on($("[data-announce-next]", bar), "click", function () { show(idx + 1); });
      on($("[data-announce-prev]", bar), "click", function () { show(idx - 1); });
      var ms = parseInt(bar.getAttribute("data-autorotate"), 10) || 0;
      if (ms > 0 && !REDUCED && !DESIGN()) {
        bar._timer = window.setInterval(function () { show(idx + 1); }, ms);
        on(bar, "mouseenter", function () { window.clearInterval(bar._timer); });
      }
    });
  }

  /* ---------- Shop-the-look hotspots ---------- */
  function initHotspots(root) {
    root = root || document;
    var spots = $$(".hotspot", root);
    spots.forEach(function (h) {
      if (!boundOnce(h, "spot")) return;
      on(h, "click", function (e) {
        e.preventDefault();
        var was = h.classList.contains("is-active");
        spots.forEach(function (x) { x.classList.remove("is-active"); });
        if (!was) h.classList.add("is-active");
      });
    });
    $$(".look__media,[data-look-media]", root).forEach(function (m) {
      if (!boundOnce(m, "lookmedia")) return;
      on(m, "click", function (e) { if (!e.target.closest(".hotspot")) spots.forEach(function (x) { x.classList.remove("is-active"); }); });
    });
  }

  /* ---------- PDP gallery ---------- */
  /* The main gallery <img> is rendered by image_tag with a widths list, so it
     carries a srcset. A browser resolves the displayed image from srcset and
     ignores src outright — swapping src alone silently does nothing. Always
     replace both: a matching srcset when we have one, otherwise drop it so src
     is honoured again. */
  function swapGalleryImage(img, url, srcset) {
    if (!img || !url) return;
    if (srcset) img.setAttribute("srcset", srcset);
    else img.removeAttribute("srcset");
    img.setAttribute("src", url);
  }

  /* Product card swatches: show the clicked colour's variant image in place of
     the card's featured image. Same srcset caveat as the PDP gallery. */
  function initCardSwatches(root) {
    root = root || document;
    $$("[data-card-swatch]", root).forEach(function (sw) {
      if (!boundOnce(sw, "cardsw")) return;
      on(sw, "click", function (e) {
        e.preventDefault();
        var card = sw.closest(".card");
        var img = card ? $(".card__media img", card) : null;
        var nextImage = sw.getAttribute("data-img");
        if (img && nextImage) swapGalleryImage(img, nextImage, sw.getAttribute("data-srcset"));
        var group = sw.closest("[data-card-swatches]");
        if (group) {
          $$("[data-card-swatch]", group).forEach(function (x) {
            x.setAttribute("aria-pressed", "false");
            x.classList.remove("is-active");
          });
        }
        sw.setAttribute("aria-pressed", "true");
        sw.classList.add("is-active");
        var label = group ? $("[data-card-swatch-label]", group) : null;
        if (label) label.textContent = sw.getAttribute("data-swatch-label") || "";
      });
    });
  }

  function initGallery(root) {
    root = root || document;
    var main = $("[data-gallery-main]", root) || $("#galleryMain", root);
    var thumbs = $$("[data-gallery-thumb]", root);
    if (!main || !thumbs.length) return;
    function selectThumb(t) {
      swapGalleryImage(main, t.getAttribute("data-full"), t.getAttribute("data-srcset"));
      thumbs.forEach(function (x) { x.setAttribute("aria-current", "false"); });
      t.setAttribute("aria-current", "true");
    }

    thumbs.forEach(function (t) {
      if (!boundOnce(t, "thumb")) return;
      on(t, "click", function () { selectThumb(t); });
    });

    var stage = main.closest(".gallery__main") || main;
    if (boundOnce(stage, "galleryswipe")) {
      var startX = 0, startY = 0;
      on(stage, "pointerdown", function (e) {
        if (!window.matchMedia("(max-width: 989px)").matches || e.isPrimary === false) return;
        startX = e.clientX;
        startY = e.clientY;
      });
      on(stage, "pointerup", function (e) {
        if (!startX || !window.matchMedia("(max-width: 989px)").matches) return;
        var dx = e.clientX - startX;
        var dy = e.clientY - startY;
        startX = 0; startY = 0;
        if (Math.abs(dx) < 45 || Math.abs(dx) <= Math.abs(dy)) return;
        var current = thumbs.findIndex(function (t) { return t.getAttribute("aria-current") === "true"; });
        var next = dx < 0 ? current + 1 : current - 1;
        if (next < 0 || next >= thumbs.length) return;
        selectThumb(thumbs[next]);
        thumbs[next].scrollIntoView({ behavior: REDUCED ? "auto" : "smooth", block: "nearest", inline: "center" });
      });
      on(stage, "pointercancel", function () { startX = 0; startY = 0; });
    }
  }

  /* ---------- Variant picker (full resolution: price, availability, media) ---------- */
  function initVariantPicker(root) {
    root = root || document;
    $$("[data-variant-picker]", root).forEach(function (picker) {
      if (!boundOnce(picker, "variant")) return;
      var dataEl = $("[data-variant-data]", picker);
      if (!dataEl) return;
      var variants;
      try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
      var scope = picker.closest("[data-product-root]") || document;
      var form = picker.closest("form");
      var idInput = form ? (form.querySelector("[data-variant-id]") || form.querySelector('[name="id"]')) : null;
      var priceEl = $("[data-price]", scope);
      var addBtn = form ? form.querySelector("[data-add-button]") : null;
      var galleryImg = $(".gallery__main img", scope);

      function readSelection() {
        var opts = [];
        $$("fieldset[data-option-position]", picker).forEach(function (fs) {
          var pos = parseInt(fs.getAttribute("data-option-position"), 10);
          var sel = $("select[data-variant-option]", fs);
          var val = sel ? sel.value : (fs.querySelector("input[data-variant-option]:checked") || {}).value;
          opts[pos - 1] = val || null;
          var lbl = $("[data-option-value]", fs);
          if (lbl && val) lbl.textContent = val;
          $$("input[data-variant-option]", fs).forEach(function (x) {
            var l = fs.querySelector('label[for="' + x.id + '"]');
            if (l) l.setAttribute("aria-current", x.checked ? "true" : "false");
          });
        });
        return opts;
      }

      function update() {
        var o = readSelection();
        var match = variants.filter(function (v) {
          return (v.option1 == null || v.option1 === o[0]) && (v.option2 == null || v.option2 === o[1]) && (v.option3 == null || v.option3 === o[2]);
        })[0];
        if (!match) return;
        if (idInput) idInput.value = match.id;
        if (priceEl) priceEl.innerHTML = match.on_sale
          ? '<s class="price__was">' + match.compare_at + '</s> <span class="price__now">' + match.price + '</span>'
          : match.price;
        if (addBtn) {
          addBtn.disabled = !match.available;
          addBtn.setAttribute("aria-disabled", match.available ? "false" : "true");
          addBtn.textContent = match.available
            ? (addBtn.getAttribute("data-label-add") || "Add to cart")
            : (addBtn.getAttribute("data-label-sold-out") || "Sold out");
        }
        /* match.media is a single URL with no srcset of its own, so the main
           image's inherited srcset has to go or it keeps winning over src. */
        if (galleryImg && match.media) swapGalleryImage(galleryImg, match.media, null);
        picker.dispatchEvent(new CustomEvent("variant:change", { detail: match, bubbles: true }));
      }
      $$("[data-variant-option]", picker).forEach(function (inp) { on(inp, "change", update); });


       /* The gallery opens on product.featured_media, which is not necessarily
         Shopify's first available variant. Select the variant whose media is
         already visible so the picker, form and image share one initial state. */
      if (galleryImg) {
        var galleryPath = (function (url) {
          try { return new URL(url, window.location.href).pathname; } catch (e) { return ""; }
        })(galleryImg.currentSrc || galleryImg.src);
        var initial = variants.filter(function (v) {
          if (!v.media) return false;
          try { return new URL(v.media, window.location.href).pathname === galleryPath; } catch (e) { return false; }
        })[0];
        if (initial) {
          $$("fieldset[data-option-position]", picker).forEach(function (fs) {
            var pos = parseInt(fs.getAttribute("data-option-position"), 10);
            var value = initial["option" + pos];
            var select = $("select[data-variant-option]", fs);
            if (select) select.value = value;
            $$("input[data-variant-option]", fs).forEach(function (input) {
              input.checked = input.value === value;
            });
          });
          update();
        } else {
          readSelection();
        }
      }
    });
  }

  /* ---------- Scroll animator (IntersectionObserver, lazy single instance) ---------- */
  var animIO = null;
  function setupAnimIO() {
    if (animIO || REDUCED || !("IntersectionObserver" in window)) return;
    animIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) {
          var el = en.target;
          var delay = el.getAttribute("data-animate-delay");
          if (delay) el.style.setProperty("--anim-delay", delay + "ms");
          el.classList.add("is-visible");
          animIO.unobserve(el);
        }
      });
      /* threshold 0 (not a ratio) so sections taller than the viewport still reveal —
         a high ratio could never be reached on tall elements, leaving them stuck hidden. */
    }, { threshold: 0, rootMargin: "0px 0px -10% 0px" });
  }
  /* In the editor (or reduced-motion / no IO) reveal immediately so a re-rendered
     section is never stuck at opacity:0. On the storefront, observe and reveal on scroll. */
  function revealOrObserve(root) {
    root = root || document;
    var targets = $$("[data-animate], .stagger", root);
    if (root.nodeType === 1 && root.matches && (root.matches("[data-animate]") || root.matches(".stagger"))) targets.push(root);
    if (!targets.length) return;
    if (REDUCED || DESIGN() || !("IntersectionObserver" in window)) {
      targets.forEach(function (t) { t.classList.add("is-visible"); });
      return;
    }
    setupAnimIO();
    targets.forEach(function (t) { if (!t.classList.contains("is-visible") && boundOnce(t, "io")) animIO.observe(t); });
  }

  /* ---------- Parallax (single live window listener; re-query on each tick) ---------- */
  var parallaxBound = false, parallaxUpdate = null;
  function initParallax() {
    if (REDUCED) return;
    if (parallaxBound) { if (parallaxUpdate) parallaxUpdate(); return; }
    parallaxBound = true;
    var ticking = false;
    parallaxUpdate = function () {
      $$("[data-parallax]").forEach(function (el) {
        var rect = el.getBoundingClientRect();
        var speed = parseFloat(el.getAttribute("data-parallax")) || 0.2;
        var offset = (rect.top + rect.height / 2 - window.innerHeight / 2) * -speed;
        el.style.setProperty("--parallax-y", offset.toFixed(1) + "px");
      });
      ticking = false;
    };
    on(window, "scroll", function () { if (!ticking) { window.requestAnimationFrame(parallaxUpdate); ticking = true; } }, { passive: true });
    parallaxUpdate();
  }

  /* ---------- Scroll progress bar ---------- */
  function initProgressBar() {
    var bar = $("[data-progress-fill]"); if (!bar) return;
    function update() {
      var h = document.documentElement.scrollHeight - window.innerHeight;
      bar.style.setProperty("--progress", (h > 0 ? (window.pageYOffset / h) * 100 : 0) + "%");
    }
    on(window, "scroll", update, { passive: true }); update();
  }

  /* ---------- Locale selector ---------- */
  function initLocale(root) {
    root = root || document;
    $$(".locale-form", root).forEach(function (form) {
      if (!boundOnce(form, "locale")) return;
      var toggle = $(".locale__toggle", form);
      on(toggle, "click", function (e) { e.preventDefault(); form.classList.toggle("is-open"); if (toggle) toggle.setAttribute("aria-expanded", form.classList.contains("is-open") ? "true" : "false"); });
    });
  }
  /* Single global outside-click closes any open locale form. */
  function initLocaleGlobal() {
    on(document, "click", function (e) {
      $$(".locale-form.is-open").forEach(function (form) { if (!form.contains(e.target)) form.classList.remove("is-open"); });
    });
  }

  /* ---------- Button ripple ---------- */
  function initRipple(root) {
    if (REDUCED) return;
    root = root || document;
    $$(".btn.hover-ripple,[data-ripple]", root).forEach(function (btn) {
      if (!boundOnce(btn, "ripple")) return;
      on(btn, "click", function (e) {
        var r = document.createElement("span");
        r.className = "btn__ripple";
        var rect = btn.getBoundingClientRect();
        r.style.setProperty("--rx", (e.clientX - rect.left) + "px");
        r.style.setProperty("--ry", (e.clientY - rect.top) + "px");
        btn.appendChild(r);
        window.setTimeout(function () { r.remove(); }, 600);
      });
    });
  }

  /* ---------- Text splitter (for split-chars/words reveal) ---------- */
  function initTextSplitter(root) {
    if (REDUCED) return;
    root = root || document;
    $$("[data-split]", root).forEach(function (el) {
      if (!boundOnce(el, "split")) return;
      var mode = el.getAttribute("data-split");
      var parts = mode === "chars" ? el.textContent.split("") : el.textContent.split(" ");
      el.textContent = "";
      parts.forEach(function (p, i) {
        var span = document.createElement("span");
        span.className = "split-part";
        span.textContent = mode === "chars" ? p : p + " ";
        span.style.setProperty("--i", i);
        el.appendChild(span);
      });
    });
  }

  /* ---------- Countdown ---------- */
  function initCountdown(root) {
    root = root || document;
    $$("[data-countdown]", root).forEach(function (el) {
      if (!boundOnce(el, "cd")) return;
      var end = new Date(el.getAttribute("data-countdown")).getTime();
      if (isNaN(end)) return;
      function tick() {
        var diff = Math.max(0, end - Date.now());
        var d = Math.floor(diff / 864e5), h = Math.floor(diff % 864e5 / 36e5), m = Math.floor(diff % 36e5 / 6e4), s = Math.floor(diff % 6e4 / 1e3);
        var map = { days: d, hours: h, minutes: m, seconds: s };
        Object.keys(map).forEach(function (k) { var n = $("[data-cd='" + k + "']", el); if (n) n.textContent = ("0" + map[k]).slice(-2); });
        if (diff <= 0) window.clearInterval(el._cd);
      }
      el._cd = window.setInterval(tick, 1000); tick();
    });
  }

  /* ---------- Wishlist store (localStorage, keyed by product handle) ----------
     Handles rather than IDs: the wishlist page rehydrates each saved product
     through /products/{handle}?section_id=wishlist-card, and there is no
     storefront route that resolves a bare numeric product ID. */
  var Wishlist = (function () {
    var KEY = "reve_wishlist_v2";
    function read() {
      try {
        var raw = JSON.parse(localStorage.getItem(KEY));
        if (!Array.isArray(raw)) return [];
        return raw.filter(function (h) { return typeof h === "string" && h.length; });
      } catch (e) { return []; }
    }
    function persist(list) { try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {} }
    function announce(list) {
      document.dispatchEvent(new CustomEvent("wishlist:change", { detail: { items: list.slice() } }));
    }
    function commit(list) { persist(list); announce(list); }
    return {
      all: read,
      count: function () { return read().length; },
      has: function (handle) { return read().indexOf(handle) > -1; },
      toggle: function (handle) {
        var list = read(), i = list.indexOf(handle);
        if (i > -1) list.splice(i, 1); else list.push(handle);
        commit(list);
        return list.indexOf(handle) > -1;
      },
      remove: function (handle) {
        var list = read(), i = list.indexOf(handle);
        if (i < 0) return;
        list.splice(i, 1);
        commit(list);
      },
      /* Prune a handle the storefront no longer serves (product deleted or
         unpublished). Silent: callers are mid-render and repaint themselves,
         so announcing here would recurse. */
      drop: function (handle) {
        var list = read(), i = list.indexOf(handle);
        if (i < 0) return;
        list.splice(i, 1);
        persist(list);
      },
      clear: function () { commit([]); },
      announce: function () { announce(read()); }
    };
  })();

  /* ---------- Wishlist buttons + counts ---------- */
  function syncWishlistButton(btn) {
    var handle = btn.getAttribute("data-wishlist");
    if (!handle) return;
    var active = Wishlist.has(handle);
    btn.classList.toggle("is-active", active);
    btn.setAttribute("aria-pressed", active ? "true" : "false");
    var label = btn.getAttribute(active ? "data-label-remove" : "data-label-add");
    if (label) {
      btn.setAttribute("aria-label", label);
      var txt = $("[data-wishlist-text]", btn);
      if (txt) txt.textContent = label;
    }
  }

  function syncWishlistCounts() {
    var n = Wishlist.count();
    $$("[data-wishlist-count]").forEach(function (el) { el.textContent = n; });
  }

  function initWishlist(root) {
    root = root || document;
    $$("[data-wishlist]", root).forEach(function (btn) {
      syncWishlistButton(btn);
      if (!boundOnce(btn, "wish")) return;
      on(btn, "click", function (e) {
        e.preventDefault();
        var handle = btn.getAttribute("data-wishlist");
        if (!handle) return;
        Wishlist.toggle(handle);
        if (!REDUCED) {
          btn.classList.add("is-bumping");
          window.setTimeout(function () { btn.classList.remove("is-bumping"); }, 450);
        }
      });
    });
    syncWishlistCounts();
  }

  /* ---------- Wishlist: global listeners (bind once) ---------- */
  function initWishlistGlobal() {
    on(document, "wishlist:change", function () {
      $$("[data-wishlist]").forEach(syncWishlistButton);
      syncWishlistCounts();
    });
    /* Fires only in OTHER tabs, so this cannot loop back on itself. */
    on(window, "storage", function (e) {
      if (e.key !== "reve_wishlist_v2") return;
      $$("[data-wishlist]").forEach(syncWishlistButton);
      syncWishlistCounts();
      Wishlist.announce();
    });
  }

  /* ---------- Wishlist page ---------- */
  function initWishlistPage(root) {
    var page = $("[data-wishlist-page]", root || document);
    if (!page) return;

    var grid = $("[data-wishlist-grid]", page);
    if (!grid) return;
    var empty = $("[data-wishlist-empty]", page);
    var loading = $("[data-wishlist-loading]", page);
    var actions = $("[data-wishlist-actions]", page);
    var countEl = $("[data-wishlist-page-count]", page);
    var clearBtn = $("[data-wishlist-clear]", page);
    var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
    if (rootUrl.slice(-1) !== "/") rootUrl += "/";
    var pending = {}; /* handles whose card fetch is in flight */

    function nodes() { return $$("[data-wishlist-item]", grid); }
    /* Cards mid-exit are still in the DOM but no longer count as saved. */
    function liveNodes() {
      return nodes().filter(function (n) { return !n.classList.contains("is-leaving"); });
    }
    function nodeFor(handle) {
      return nodes().filter(function (n) { return n.getAttribute("data-wishlist-item") === handle; })[0];
    }

    function fetchCard(handle) {
      return window
        .fetch(rootUrl + "products/" + encodeURIComponent(handle) + "?section_id=wishlist-card", {
          headers: { "X-Requested-With": "XMLHttpRequest" }
        })
        .then(function (r) {
          if (!r.ok) throw new Error("unavailable");
          return r.text();
        })
        .then(function (html) {
          var holder = document.createElement("div");
          holder.innerHTML = html.trim();
          var card = holder.querySelector("[data-wishlist-item]");
          if (!card) throw new Error("empty");
          return card;
        })
        .catch(function () {
          Wishlist.drop(handle);
          return null;
        });
    }

    function paint() {
      /* Two different counts: the grid must stay mounted while a card fades
         out, but that card is already gone as far as the tally is concerned. */
      var mounted = nodes().length;
      var saved = liveNodes().length;
      grid.hidden = mounted === 0;
      if (empty) empty.hidden = mounted > 0;
      if (actions) actions.hidden = saved === 0;
      if (countEl) {
        countEl.hidden = saved === 0;
        var one = countEl.getAttribute("data-count-one") || "1 saved";
        var many = countEl.getAttribute("data-count-many") || "[[n]] saved";
        countEl.textContent = saved === 1 ? one : many.replace("[[n]]", saved);
      }
      syncWishlistCounts();
    }

    function busy(state) {
      grid.setAttribute("aria-busy", state ? "true" : "false");
      if (loading) loading.hidden = !state;
    }

    /* Reconciles the DOM against the store: drop cards that are gone, fetch
       cards that are new. First run starts from an empty grid, so it doubles
       as the initial render — and a removal never refetches survivors. */
    function sync() {
      var list = Wishlist.all();
      var present = nodes().map(function (n) { return n.getAttribute("data-wishlist-item"); });

      nodes().forEach(function (n) {
        var handle = n.getAttribute("data-wishlist-item");
        if (list.indexOf(handle) > -1) {
          /* Re-saved while fading out — call off the removal and fade it back
             in, otherwise the pending timer deletes a card that is saved. */
          if (n._wlExit) {
            window.clearTimeout(n._wlExit);
            n._wlExit = null;
            n.classList.remove("is-leaving");
          }
          return;
        }
        if (n._wlExit) return;
        if (REDUCED) { n.remove(); return; }
        n.classList.add("is-leaving");
        n._wlExit = window.setTimeout(function () { n._wlExit = null; n.remove(); paint(); }, 250);
      });

      /* Skip anything already in flight: overlapping syncs (two quick saves,
         a storage event from another tab) would otherwise each fetch the same
         handle and append it twice. */
      var missing = list.filter(function (h) {
        return present.indexOf(h) === -1 && !pending[h];
      });
      if (!missing.length) { paint(); return Promise.resolve(); }

      missing.forEach(function (h) { pending[h] = true; });
      busy(true);
      return Promise.all(
        missing.map(function (h) {
          return fetchCard(h).then(function (card) {
            delete pending[h];
            return { handle: h, card: card };
          });
        })
      ).then(function (results) {
        results.forEach(function (r) {
          if (!r.card) return;
          if (nodeFor(r.handle)) return;
          /* Unsaved while its card was in flight — drop it on the floor. */
          if (Wishlist.all().indexOf(r.handle) === -1) return;
          grid.appendChild(r.card);
        });
        /* Re-append in stored order so the grid matches the saved sequence. */
        Wishlist.all().forEach(function (h) {
          var n = nodeFor(h);
          if (n) grid.appendChild(n);
        });
        for (var k in pending) { if (pending[k]) { paint(); return; } }
        busy(false);
        paint();
        initWishlist(grid);
        initCart(grid);
        initCardSwatches(grid);
        revealOrObserve(grid);
      });
    }

    if (clearBtn && boundOnce(clearBtn, "wishclear")) {
      on(clearBtn, "click", function () { Wishlist.clear(); });
    }
    if (boundOnce(page, "wishpage")) {
      on(document, "wishlist:change", function () { sync(); });
    }
    sync();
  }

  /* ---------- Cart: AJAX add / change / remove + drawer + free-ship bar ---------- */
  function initCart(root) {
    root = root || document;
    var cartRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
    function bump() { var icon = $("[data-cart-icon]"); if (icon && !REDUCED) { icon.classList.add("is-bumping"); window.setTimeout(function () { icon.classList.remove("is-bumping"); }, 450); } }
    function updateCount(cart) { $$("[data-cart-count]").forEach(function (el) { el.textContent =  cart.item_count; }); }
    function setShipBars(scope) { $$("[data-ship-fill]", scope || document).forEach(function (el) { el.style.setProperty("--ship-w", (el.getAttribute("data-pct") || 0) + "%"); }); }
    function change(key, qty) {
      return window.fetch("/cart/change.js", { method: "POST", headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" }, body: JSON.stringify({ id: key, quantity: qty }) }).then(function (r) { return r.json(); }).then(function (cart) { updateCount(cart); return cart; });
    }
    function refresh() {
      var drawer = $("[data-cart-drawer]");
      var sectionId = drawer && drawer.getAttribute("data-section-id") || "cart-drawer";
      var currentNote = $("[data-cart-note]");
      var noteValue = currentNote ? currentNote.value : null;
      return window.fetch(cartRoot + "?section_id=" + encodeURIComponent(sectionId)).then(function (r) { return r.text(); }).then(function (html) {
        var content = $("[data-cart-drawer-content]");
        if (content) {
          var doc = new DOMParser().parseFromString(html, "text/html");
          var fresh = $("[data-cart-drawer-content]", doc);
          if (fresh) {
            content.innerHTML = fresh.innerHTML;
            var refreshedNote = $("[data-cart-note]", content);
            if (refreshedNote && noteValue !== null) refreshedNote.value = noteValue;
          }
        }
        bindLines(document); setShipBars(document);
      }).catch(function () {});
    }
    function showCartError(form, btn, data) {
      var msg = (data && (data.description || data.message)) || "Sorry, this item could not be added to your cart.";
      var scope = form.closest("[data-product-root]") || form;
      var box = scope.querySelector("[data-cart-error]");
      if (!box) {
        box = document.createElement("p");
        box.className = "cart-error";
        box.setAttribute("data-cart-error", "");
        box.setAttribute("role", "alert");
        if (btn && btn.parentNode) btn.parentNode.insertBefore(box, btn.nextSibling);
        else form.appendChild(box);
      }
      box.textContent = msg;
    }
    function bindLines(scope) {
      $$("[data-cart-line]", scope || document).forEach(function (row) {
        if (!boundOnce(row, "line")) return;
        var key = row.getAttribute("data-cart-line");
        var minus = $("[data-line-minus]", row), plus = $("[data-line-plus]", row), val = $("[data-line-qty]", row), rm = $("[data-line-remove]", row);
        function cur() { return parseInt(val && val.textContent, 10) || 1; }
        on(minus, "click", function () { change(key, Math.max(0, cur() - 1)).then(refresh); });
        on(plus, "click", function () { change(key, cur() + 1).then(refresh); });
        on(rm, "click", function (e) { e.preventDefault(); change(key, 0).then(refresh); });
      });
    }
    $$("[data-add-to-cart]", root).forEach(function (form) {
      if (!boundOnce(form, "atc")) return;
      on(form, "submit", function (e) {
        if (!window.fetch) return;
        e.preventDefault();
        var btn = form.querySelector("[data-add-button]") || $('[type="submit"]', form); if (btn) btn.setAttribute("aria-busy", "true");
        window.fetch("/cart/add.js", { method: "POST", body: new FormData(form), headers: { "X-Requested-With": "XMLHttpRequest" } })
          .then(function (r) { return r.json().then(function (data) { if (!r.ok) { var e = new Error("cart"); e.cartError = data; throw e; } return data; }); })
          .then(function () { return window.fetch("/cart.js").then(function (r) { return r.json(); }); })
          .then(function (cart) { updateCount(cart); bump(); return refresh(); })
          .then(function () { var d = $("[data-cart-drawer]"); if (d) OverlayManager.open(d, btn); })
          .catch(function (err) { if (err && err.cartError) showCartError(form, btn, err.cartError); else form.submit(); })
          .then(function () { if (btn) btn.removeAttribute("aria-busy"); });
      });
    });
    bindLines(root); setShipBars(root);
  }

  /* ---------- Collection filters (auto-submit) + load more ---------- */
  function initFilters(root) {
    root = root || document;
    $$("[data-collection-filters]", root).forEach(function (form) {
      if (!boundOnce(form, "filters")) return;
      $$("input, select", form).forEach(function (inp) {
        on(inp, "change", function () { if (typeof form.requestSubmit === "function") form.requestSubmit(); else form.submit(); });
      });
    });
    function togglePanel(open) {
      var panel = $("[data-filter-panel]"); if (!panel) return;
      panel.classList.toggle("is-open", open);
      document.body.classList.toggle("no-scroll", open);
    }
    $$("[data-filter-toggle]", root).forEach(function (b) { if (boundOnce(b, "ftog")) on(b, "click", function () { togglePanel(true); }); });
    $$("[data-filter-close]", root).forEach(function (b) { if (boundOnce(b, "fcls")) on(b, "click", function () { togglePanel(false); }); });
  }
  function initLoadMore(root) {
    root = root || document;
    $$("[data-load-more]", root).forEach(function (btn) {
      if (!boundOnce(btn, "loadmore")) return;
      on(btn, "click", function (e) {
        e.preventDefault();
        var url = btn.getAttribute("data-next-url");
        if (!url || !window.fetch) return;
        btn.setAttribute("aria-busy", "true");
        window.fetch(url).then(function (r) { return r.text(); }).then(function (html) {
          var doc = new DOMParser().parseFromString(html, "text/html");
          var grid = $("[data-product-grid]");
          var fresh = $("[data-product-grid]", doc);
          if (grid && fresh) { Array.prototype.forEach.call(fresh.children, function (n) { grid.appendChild(n); }); }
          var count = $("[data-load-more-count]");
          if (count && grid) {
            var template = count.getAttribute("data-template") || "Showing [[count]] of " + count.getAttribute("data-total");
            count.textContent = template.replace("[[count]]", grid.children.length);
          }
          var nextBtn = $("[data-load-more]", doc);
          if (nextBtn && nextBtn.getAttribute("data-next-url")) { btn.setAttribute("data-next-url", nextBtn.getAttribute("data-next-url")); }
          else { btn.remove(); }
          btn.removeAttribute("aria-busy");
          if (grid) { initCart(grid); initWishlist(grid); initCardSwatches(grid); revealOrObserve(grid); }
        }).catch(function () { btn.removeAttribute("aria-busy"); });
      });
    });
  }

  /* ---------- Product recommendations (Shopify API) ---------- */
  function initRecommendations(root) {
    root = root || document;
    $$("[data-product-recommendations]", root).forEach(function (el) {
      if (!boundOnce(el, "recs")) return;
      var url = el.getAttribute("data-url");
      if (!url || !window.fetch) return;
      window.fetch(url).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, "text/html");
        var fresh = $("[data-product-recommendations]", doc);
        if (fresh && fresh.innerHTML.trim()) { el.innerHTML = fresh.innerHTML; initCart(el); revealOrObserve(el); initWishlist(el); initCardSwatches(el); }
      }).catch(function () {});
    });
  }

  /* ---------- Popup manager ---------- */
  function initPopup(root) {
    root = root || document;
    var popup = $("[data-popup]", root); if (!popup) return;
    if (!boundOnce(popup, "popup")) return;
    var freq = popup.getAttribute("data-frequency") || "once-per-day";
    var KEY = "reve_popup_seen";
    function seen() { try { return localStorage.getItem(KEY); } catch (e) { return null; } }
    function mark() { try { localStorage.setItem(KEY, String(Date.now())); } catch (e) {} }
    /* Always show in the editor so merchants can style it; respect frequency on storefront. */
    if (!DESIGN() && freq !== "every-visit" && seen()) {
      var last = parseInt(seen(), 10);
      var ms = { "once-per-day": 864e5, "once-per-week": 6048e5, "once-per-session": Infinity }[freq] || 864e5;
      if (freq === "once-per-session" || Date.now() - last < ms) return;
    }
    var delay = (parseInt(popup.getAttribute("data-delay"), 10) || 8) * 1000;
    function show() { popup.classList.add("is-open"); mark(); }
    window.setTimeout(show, DESIGN() ? 300 : delay);
    $$("[data-popup-close]", popup).forEach(function (b) { on(b, "click", function () { popup.classList.remove("is-open"); }); });
  }

  /* ---------- Lazy image fade ---------- */
  function initLazyImages(root) {
    root = root || document;
    $$("img[loading='lazy']", root).forEach(function (img) {
      if (!boundOnce(img, "lazy")) return;
      img.classList.add("lazy-img");
      if (img.complete) img.classList.add("is-loaded");
      else on(img, "load", function () { img.classList.add("is-loaded"); });
    });
  }

  /* ---------- Per-section init (run on first load + every shopify:section:load) ---------- */
  function initScope(root) {
    root = root || document;
    initOverlayTriggers(root);
    initDesktopNav(root);
    initTabs(root);
    initQuantity(root);
    initSlideshow(root);
    initAnnouncement(root);
    initHotspots(root);
    initGallery(root);
    initCardSwatches(root);
    initVariantPicker(root);
    initParallax();
    initRipple(root);
    initTextSplitter(root);
    initCountdown(root);
    initWishlist(root);
    initWishlistPage(root);
    initCart(root);
    initFilters(root);
    initLoadMore(root);
    initLocale(root);
    initRecommendations(root);
    initPopup(root);
    initLazyImages(root);
    revealOrObserve(root);
  }

  /* ---------- Global init (window/document listeners — bind once) ---------- */
  function initGlobal() {
    initOverlayGlobal();
    initStickyHeader();
    initProgressBar();
    initLocaleGlobal();
    initWishlistGlobal();
  }

  /* ---------- Theme editor cleanup on section unload ---------- */
  function cleanupScope(root) {
    if (!root) return;
    $$("[data-slideshow]", root).forEach(function (el) { if (el._timer) window.clearInterval(el._timer); });
    $$("[data-announce]", root).forEach(function (el) { if (el._timer) window.clearInterval(el._timer); });
    $$("[data-countdown]", root).forEach(function (el) { if (el._cd) window.clearInterval(el._cd); });
    if (root.matches && root.matches("[data-announce]") && root._timer) window.clearInterval(root._timer);
  }

  /* ---------- Theme editor: keep a selected block visible/active ---------- */
  function handleBlockSelect(e) {
    var block = e.target;
    /* Slideshow → slide to the selected block. */
    var slideshow = block.closest && block.closest("[data-slideshow]");
    if (slideshow && slideshow._goToSlide) {
      var track = $("[data-slides]", slideshow);
      if (track) {
        var kids = Array.prototype.slice.call(track.children);
        var slide = block;
        while (slide && slide.parentNode !== track) { slide = slide.parentNode; if (slide === slideshow) { slide = null; break; } }
        var i = slide ? kids.indexOf(slide) : -1;
        if (i > -1) slideshow._goToSlide(i);
      }
    }
    /* Hotspot block → activate it. */
    if (block.classList && block.classList.contains("hotspot")) {
      $$(".hotspot").forEach(function (x) { x.classList.remove("is-active"); });
      block.classList.add("is-active");
    }
    /* Accordion/details block → open it. */
    var det = (block.matches && block.matches("details")) ? block : (block.querySelector && block.querySelector("details"));
    if (det) det.open = true;
    /* Tab block → select it. */
    if (block.matches && block.matches('[role="tab"], .tab')) block.click();
  }
  function handleBlockDeselect(e) {
    var block = e.target;
    if (block.classList && block.classList.contains("hotspot")) block.classList.remove("is-active");
  }

  function bindEditorEvents() {
    document.addEventListener("shopify:section:load", function (e) { initScope(e.target); });
    document.addEventListener("shopify:section:unload", function (e) { cleanupScope(e.target); });
    document.addEventListener("shopify:block:select", handleBlockSelect);
    document.addEventListener("shopify:block:deselect", handleBlockDeselect);
  }

  /* ---------- Boot ---------- */
  function init() {
    initGlobal();
    initScope(document);
    bindEditorEvents();
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();

  window.ReveTheme = { OverlayManager: OverlayManager, initScope: initScope };
})();
